// --- tiny helpers ---
function hideItems(selector) {
  document.querySelectorAll(selector).forEach(el => {
    el.style.display = 'none';
    el.setAttribute('aria-hidden', 'true');
  });
}
function showItems(selector) {
  document.querySelectorAll(selector).forEach(el => {
    el.style.display = 'block';
    el.removeAttribute('aria-hidden');
  });
}
function resetRadio(selector) {
  document.querySelectorAll(selector).forEach(r => { r.checked = false; });
}
function resetValues(selector) {
  document.querySelectorAll(selector).forEach(el => { if ('value' in el) el.value = ''; });
}
function setRequired(selector, on) {
  document.querySelectorAll(selector).forEach(el => {
    if (on) { el.classList.add('validate'); el.setAttribute('required','true'); }
    else { el.classList.remove('validate'); el.removeAttribute('required'); }
  });
  if (typeof checkForm === 'function') checkForm('drive-design-form');
}

// --- geometry toggles (Step-3) ---
function prevod_geometry_items() {
  hideItems('.spojka-geometry-item');
  showItems('.prevod-geometry-item');
}
function spojka_geometry_items() {
  hideItems('.prevod-geometry-item');
  showItems('.spojka-geometry-item');
}

// --- checkbox-controlled blocks (one-time bind) ---
function handleCheckboxDisplay(toggleId, boxId) {
  const t = document.getElementById(toggleId);
  const box = document.getElementById(boxId);
  if (!t || !box) return;
  box.style.display = t.checked ? 'block' : 'none';
  if (!t.dataset.bound) {
    t.addEventListener('change', () => { box.style.display = t.checked ? 'block' : 'none'; });
    t.dataset.bound = '1';
  }
}

// --- Step-3 enable/disable for CONTINUITY ---
const STEP3_SEL = '.fieldset-box-step-3 input, .fieldset-box-step-3 textarea';
function snapshotStep3Once() {
  document.querySelectorAll(STEP3_SEL).forEach(el => {
    if (el.dataset.ss) return; // only once
    el.dataset.req = el.hasAttribute('required') ? '1' : '0';
    el.dataset.val = el.classList.contains('validate') ? '1' : '0';
    el.dataset.ss  = '1';
  });
}
function disableStep3() {
  snapshotStep3Once();
  hideItems('.fieldset-box-step-3');
  document.querySelectorAll(STEP3_SEL).forEach(el => {
    el.disabled = true;
    el.classList.remove('validate');
    el.removeAttribute('required');
    if (el.type === 'checkbox' || el.type === 'radio') el.checked = false;
    else if ('value' in el) el.value = '';
  });
  if (typeof checkForm === 'function') checkForm('drive-design-form');
}
function enableStep3() {
  snapshotStep3Once();
  showItems('.fieldset-box-step-3');
  document.querySelectorAll(STEP3_SEL).forEach(el => {
    el.disabled = false;
    if (el.dataset.req === '1') el.setAttribute('required','true'); else el.removeAttribute('required');
    if (el.dataset.val === '1') el.classList.add('validate'); else el.classList.remove('validate');
  });
  if (typeof checkForm === 'function') checkForm('drive-design-form');
}

// --- Step-2 groups wiring ---
function activateStep2Group(mode) {
  // mode: 'novy' | 'old' | 'continuity'
  if (mode === 'novy') {
    showItems('.fieldset-box-step-2');
    showItems('.new-subject-item');
    hideItems('.old-subject-item, .continuity-item');
    setRequired('.new-subject-item input[name="predmet"]', true);
    setRequired('.old-subject-item input[name="predmet"], .continuity-item input[name="predmet"]', false);
  } else if (mode === 'old') {
    showItems('.fieldset-box-step-2');
    showItems('.old-subject-item');
    hideItems('.new-subject-item, .continuity-item');
    setRequired('.old-subject-item input[name="predmet"]', true);
    setRequired('.new-subject-item input[name="predmet"], .continuity-item input[name="predmet"]', false);
  } else {
    showItems('.fieldset-box-step-2');
    showItems('.continuity-item');
    hideItems('.new-subject-item, .old-subject-item');
    setRequired('.continuity-item input[name="predmet"]', true);
    setRequired('.new-subject-item input[name="predmet"], .old-subject-item input[name="predmet"]', false);
  }
}

// --- init + events ---
document.addEventListener('DOMContentLoaded', () => {
  // capture Step-3 baseline BEFORE any toggling
  snapshotStep3Once();

  // hide steps initially
  hideItems('.fieldset-box-step-2, .fieldset-box-step-3');

  // Step-1 change handler
  document.querySelectorAll('.fieldset-box-step-1 input[name="vypocet"]').forEach(r => {
    r.addEventListener('change', () => {
      // clear Step-2 radios + the "old" text field
      resetRadio('.fieldset-box-step-2 input[name="predmet"]');
      const oldTxt = document.getElementById('predmet__stavajici'); if (oldTxt) oldTxt.value = '';

      const sel = document.querySelector('.fieldset-box-step-1 input[name="vypocet"]:checked');
      if (!sel) return;

      if (sel.value === 'continuity') {
        activateStep2Group('continuity');
        disableStep3(); // Step-3 is off for CONTINUITY
      } else {
        const mode = (sel.value === 'novy') ? 'novy' : 'old';
        activateStep2Group(mode);
        hideItems('.fieldset-box-step-3'); // wait for Step-2 choice
        // do NOT call enableStep3() here
      }
    });
  });

  // Step-2 change (delegated)
  const step2 = document.querySelector('.fieldset-box-step-2');
  if (step2) {
    step2.addEventListener('change', (e) => {
      const t = e.target;
      if (!t || t.name !== 'predmet') return;

      const step1 = document.querySelector('.fieldset-box-step-1 input[name="vypocet"]:checked');
      if (step1 && step1.value === 'continuity') {
        // CONTINUITY doesn't use Step-3
        return;
      }

      // Geometry choice
      if (t.value === 'spojka' || (t.id && t.id.indexOf('spojka') !== -1)) {
        spojka_geometry_items();
      } else {
        prevod_geometry_items();
      }

      // Re-enable + show Step-3 and wire sub-blocks
      enableStep3();
      showItems('.fieldset-box-step-3');
      handleCheckboxDisplay('okoli', 'okoli-box');
      handleCheckboxDisplay('okoli__olej', 'okoli-olej-box');
      handleCheckboxDisplay('okoli__chemikalie', 'okoli-chemikalie-box');
      handleCheckboxDisplay('okoli__jine', 'okoli-jine-box');
      handleCheckboxDisplay('kladka', 'kladka-box');
      handleCheckboxDisplay('pozadavky', 'pozadavky-box');
    });
  }

  // --- initial state from server preselects ---
  const preStep1 = document.querySelector('.fieldset-box-step-1 input[name="vypocet"]:checked');
  if (preStep1) {
    if (preStep1.value === 'continuity') {
      activateStep2Group('continuity');
      disableStep3();
    } else {
      const mode = (preStep1.value === 'novy') ? 'novy' : 'old';
      activateStep2Group(mode);

      const prePredmet = document.querySelector('.fieldset-box-step-2 input[name="predmet"]:checked');
      if (prePredmet) {
        if (prePredmet.value === 'spojka' || (prePredmet.id && prePredmet.id.indexOf('spojka') !== -1)) {
          spojka_geometry_items();
        } else {
          prevod_geometry_items();
        }
        enableStep3();
        showItems('.fieldset-box-step-3');
        handleCheckboxDisplay('okoli', 'okoli-box');
        handleCheckboxDisplay('okoli__olej', 'okoli-olej-box');
        handleCheckboxDisplay('okoli__chemikalie', 'okoli-chemikalie-box');
        handleCheckboxDisplay('okoli__jine', 'okoli-jine-box');
        handleCheckboxDisplay('kladka', 'kladka-box');
        handleCheckboxDisplay('pozadavky', 'pozadavky-box');
      } else {
        hideItems('.fieldset-box-step-3'); // keep hidden until user picks Step-2
      }
    }
  } else {
    hideItems('.fieldset-box-step-2, .fieldset-box-step-3');
  }
});
